<template>
  <div>
    <template v-if="searchBar">
      <div class="search-bar">
        <component :is="searchBar" ref="search" />
      </div>
    </template>
    <template v-if="displayTable">
      <div :class="{ 'panel-alert loading': isLoading }">
        <div class="panel-footer panel-top-datatable clearfix" v-if="showTopPagination">
          <div :class="`${classPaginationButtons}`">
            <vuetable-pagination
              ref="paginationTop"
              :css="pagination.css"
              @vuetable-pagination:change-page="onChangePage"
            ></vuetable-pagination>
          </div>
          <div :class="`${classPagination}`">
            <vuetable-pagination-info
              :info-template="`${paginationInfoTemplate.showing} {from} ${paginationInfoTemplate.to} {to} ${paginationInfoTemplate.of} {total}`"
              :no-data-template="noDataTemplate"
              ref="paginationInfoTop"
            ></vuetable-pagination-info>
          </div>
          <select :class="`${classSelectPagination} ajust-select`" v-model="quantPage" v-if="showSelectPagination" class="margin-top: 5px;">
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="250">250</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
            <option value="99999999">All</option>
          </select>
        </div>
        <div class="table-responsive" :class="{ 'table-with-click': !! detailRow }">
          <vuetable
            class="table-hover table-stripped"
            detail-row-component="detail-row"
            pagination-path=""
            pagination-class="vuetable-pagination"
            pagination-info-class="vuetable-pagination-info"
            pagination-component-class="vuetable-pagination-component"
            ref="datatable"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:row-clicked="show"
            @vuetable:loading="$emit('loading', true)"
            @vuetable:loaded="$emit('loading', false)"
            :pagination-component="pagination"
            :append-params="datatableParams"
            :no-data-template="noDataTemplate"
            :sort-order="sortOrder"
            :api-url="url"
            :fields="fields"
            :per-page="infoPage"
            :track-by="checkbox"
            :load-on-start="loadOnStart"
          ></vuetable>
        </div>
        <div class="panel-footer panel-footer-datatable clearfix">
          <div :class="`${classPaginationButtons}`">
            <vuetable-pagination
              ref="pagination"
              :css="pagination.css"
              @vuetable-pagination:change-page="onChangePage"
            ></vuetable-pagination>
          </div>
          <div :class="`${classPagination}`">
            <vuetable-pagination-info
              :info-template="`${paginationInfoTemplate.showing} {from} ${paginationInfoTemplate.to} {to} ${paginationInfoTemplate.of} {total}`"
              :no-data-template="noDataTemplate"
              ref="paginationInfo"
            ></vuetable-pagination-info>
          </div>
            <select :class="`${classSelectPagination} ajust-select`" v-model="quantPage" v-if="showSelectPagination" class="margin-top: 5px;">
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="250">250</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
              <option value="99999999">All</option>
            </select>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
  $body-bg: #f9f9f9;
  $laravel-border-color: darken($body-bg, 10%);
  $table-bg-hover: $body-bg;
  $panel-inner-border: $laravel-border-color;

  .ajust-select {
    margin-top: 7px !important;
  }

  .icon {
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: 'Glyphicons Halflings';
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .chevron.up.icon {
    &:before {
      content: "\e113";
    }
  }

  .chevron.down.icon {
    &:before {
      content: "\e114";
    }
  }

  .chevron {
    top: 0;
    font-size: 8px;
  }

  .search-bar {
    padding: 0 0 8px;
    background-color: $table-bg-hover;
    border-top: 1px solid $panel-inner-border;
    border-bottom: 1px solid $panel-inner-border;
    border-right: 0;
    border-left: 0;

    form {
      margin: 15px !important;

      .control-label {
        font-size: 12px;
        display: block;
      }

      .control-label, .btn {
        margin-top: 7px;
      }

      .form-control {
        width: 100%;
      }
    }
  }

  .vuetable {
    tr th:first-child,
    tr td:first-child {
      padding-left: 15px;
    }

    tr th:last-child,
    tr td:last-child {
      padding-right: 15px;
    }

    th.actions {
      width: 55px;
    }

    .vuetable-detail-row {
      background-color: $table-bg-hover;
      cursor: inherit;
    }

    dl {
      margin-bottom: 0;
    }
  }

  .vuetable-pagination-info {
    padding: 7px 0;
  }

  .table-with-click tbody tr {
    cursor: pointer;
  }

  .pagination {
    padding-right: 0;
    margin: 0;

    .btn-group > .btn {
      float: none;
    }
  }

  .table {
    margin-bottom: 0;
    font-size: 12px;
  }

  .panel-top-datatable,
  .panel-footer-datatable {
    padding-left: 0;
    padding-right: 0;
  }
</style>

<script>
  import Vue from 'vue';
  import _ from 'lodash';
  import moment from 'moment';
  import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2';

  export default {
    name: 'datatable-panel',

    props: {
      url: String,
      fields: {
        type: Array,
        default: [],
      },
      searchBar: {
        type: Object,
        default: null,
      },
      detailRow: {
        type: Object,
        default: null,
      },
      displayTableOnMounted: {
        type: Boolean,
        default: true,
      },
      sortField: {
        type: Object,
        default: null,
      },
      checkbox: {
        type: String,
        default: '',
      },
      classPagination: {
        type: String,
        default: 'col-md-4 text-right',
      },
      perPage: {
        type: Number,
        default: 10,
      },
      classPaginationButtons: {
        type: String,
        default: 'col-md-8',
      },
      deselectAfterFilter: {
        type: Boolean,
        default: true,
      },
      noDataTemplate: {
        type: String,
        default: 'Nenhum resultado encontrado.',
      },
      paginationInfoTemplate: {
        type: Object,
        default: () => {
          return {
            showing: 'Mostrando',
            to: 'até',
            of: 'de',
          }
        },
      },
      showSelectPagination: {
        type: Boolean,
        default: false,
      },
      classSelectPagination: {
        type: String,
        default: '',
      },
      loadOnStart: {
        type: Boolean,
        default: true,
      },
      showTopPagination: {
        type: Boolean,
        default: false,
      },
    },

    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
    },

    data() {
      return {
        isLoading: false,
        displayTable: '',
        datatableParams: {},
        quantPage: 50,
        pagination: {
          css: {
            wrapperClass: 'pagination btn-group',
            activeClass: 'btn-primary',
            pageClass: 'btn btn-default btn-number',
            linkClass: 'btn btn-default',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          },
        },
      };
    },

    computed: {
      infoPage() {
        if (this.showSelectPagination) {
          return Number (this.quantPage);
        }
        return Number(this.perPage);
      },
      sortOrder() {
        const sortField = _.isEmpty(this.sortField) ? this.fields[0] : this.sortField;
        return [
          {
            sortField: sortField.sortField,
            field: sortField.name,
            direction: sortField.direction || 'asc',
          },
        ];
      },
      hasPagination() {
        return this.$refs.pagination ? this.$refs.pagination.totalPage > 1 : false;
      },
    },
    watch: {
      perPage() {
        this.$nextTick(() => {
          this.$refs.datatable.reload();
        });
      },
      quantPage() {
        this.$nextTick(() => {
          this.$refs.datatable.changePage(1);
          this.$refs.datatable.reload();
        });
      },

    },

    mounted() {
      if (this.checkbox != '') {
        this.fields.unshift({
          name: '__checkbox',
        });
      }

      this.$on('loading', (isLoading) => {
        this.isLoading = isLoading;
      });

      this.displayTable = this.displayTableOnMounted;

      if (this.detailRow) {
        Vue.component('detail-row', this.detailRow);
      }

      if (this.searchBar) {
        Vue.component('search-bar', this.searchBar);
        this.$nextTick(() => {
          this.$refs.search.$on('filter-set', (filter) => {
            this.datatableParams = { filter };
            this.$nextTick(() => {
              if (this.deselectAfterFilter) {
                this.$refs.datatable.selectedTo = [];
              }
              this.$refs.datatable.refresh();
            });
          });
        });
      }
    },

    methods: {
      show(data) {
        if (this.detailRow) {
          // event.target.parentNode.classList.toggle('active');
          this.$refs.datatable.toggleDetailRow(data[this.checkbox || 'id']);
        }
      },
      refresh(url) {
        this.$refs.datatable.refresh(url);
      },
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.$refs.paginationInfo.setPaginationData(paginationData);
        if (this.showTopPagination) {
          this.$refs.paginationTop.setPaginationData(paginationData);
          this.$refs.paginationInfoTop.setPaginationData(paginationData);
        }
      },
      onChangePage(page) {
        this.$refs.datatable.changePage(page);
      },
      active(value) {
        return value === 1 ? 'Sim' : 'Não';
      },
      textDatatable(value) {
        if (value.length > 45) {
          return `${value.slice(0, 45)}...`;
        }
        return value;
      },
      displayResults() {
        this.displayTable = true;
      },
      date(value) {
        return moment(value).format('DD/MM/YYYY');
      },
      length() {
        return this.$refs.datatable.countTableData;
      },
      getSelected() {
        return this.$refs.datatable.selectedTo;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/metawesome-datatable/src/Datatable.vue